import React, { useState } from 'react';
import { Button, Col, Form, Input, Row } from 'antd';
import { UserOutlined, LockOutlined, WarningOutlined } from '@ant-design/icons';
import NgomaLogo from "../../assets/logos/rm-logo.png";
import { baseurl } from '../../components/lib/settings';
import { useNavigate } from 'react-router-dom';
import './login.css';

function Login() {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [error, setError] = useState(false);
  const [message, setMessage] = useState("");

  const onFinish = (values) => {
    setIsLoading(true);
    setMessage("");
    const data = {
      user_name: values.email,
      password: values.password,
    };
    
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("selectedEdition");

    baseurl.post("auth/login/", data).then((resp) => {
      if (resp.data.token) {
        localStorage.setItem("token", resp.data.token);

        baseurl.get("auth/user/", {
          params: { token: resp.data.token }
        })
          .then((userResp) => {
            localStorage.setItem("user", JSON.stringify(userResp.data.user));
            navigate("/dashboard");
          })
          .catch((err) => {
            setMessage("Erro ao carregar dados do utilizador.");
            setError(true);
          });
          
        // Redirection happens in then block, so isLoading(false) might not even be seen, but good practice
        setIsLoading(false);
      } else {
        setMessage("Palavra-passe ou e-mail inválidos.");
        setIsLoading(false);
        setError(true);
      }
    })
    .catch((err) => {
      setMessage("Palavra-passe ou e-mail inválidos.");
      setError(true);
      setIsLoading(false);
    });
  };

  return (
    <Row className='login-page'>
      {/* Esquerda: Branding & Apresentação Visual */}
      <Col xs={0} md={12} className='logo-section'>
        <img src={NgomaLogo} alt='Ngoma Logo' className='logo-image' />
        <div className='welcome-text'>
          <h2>Bem-vindo à Parada Musical</h2>
          <p>A plataforma centralizada de gestão e votação musical. Aceda ao seu painel para gerir submissões, consultar relatórios e acompanhar resultados em tempo real.</p>
        </div>
      </Col>

      {/* Direita: Formulário Limpo e Moderno */}
      <Col xs={24} md={12} className='form-section'>
        <div className='login-card-container'>
          
          <div className='login-header'>
            {/* Logo para mobile apenas (escondido no desktop pela grid, mas aqui renderiza se mobile) */}
            <div style={{ textAlign: 'center', marginBottom: 30 }} className="mobile-logo-wrapper">
              <img src={NgomaLogo} alt='Ngoma Logo' style={{ width: 150, display: 'inline-block' }} />
            </div>
            
            <h2>Iniciar Sessão</h2>
            <p>Introduza as suas credenciais para aceder</p>
          </div>

          {message && (
            <div className="error-message">
              <WarningOutlined style={{ marginRight: 8 }} />
              {message}
            </div>
          )}

          <Form name='login' onFinish={onFinish} layout="vertical" size="large">
            <Form.Item
              name="email"
              rules={[
                { required: true, message: 'Por favor, insira o seu e-mail!' },
              ]}
            >
              <Input
                disabled={isLoading}
                prefix={<UserOutlined className="site-form-item-icon" />}
                placeholder='Endereço de E-mail'
              />
            </Form.Item>
            
            <Form.Item
              name="password"
              rules={[
                { required: true, message: "Por favor, insira a sua palavra-passe!" },
              ]}
            >
              <Input.Password
                disabled={isLoading}
                prefix={<LockOutlined className='site-form-item-icon' />}
                placeholder='Palavra-passe'
              />
            </Form.Item>

            <div className='links'>
              <a href="#" onClick={(e) => e.preventDefault()} style={{ cursor: 'not-allowed', opacity: 0.5 }}>Recuperar palavra-passe</a>
              <a href="#" onClick={(e) => e.preventDefault()} style={{ cursor: 'not-allowed', opacity: 0.5 }}>Criar conta</a>
            </div>

            <Form.Item>
              <Button
                type='primary'
                htmlType='submit'
                className='login-form-button'
                block
                loading={isLoading}
              >
                Entrar
              </Button>
            </Form.Item>
          </Form>

          <div className="login-footer">
            Desenvolvido por <a href="https://speranza.co.mz" target="_blank" rel="noopener noreferrer">Speranza</a>
          </div>
        </div>
      </Col>
    </Row>
  );
}

export default Login;
